import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectSubdomain, selectLocationId } from '../selectors/locations';
import { useApplicationContext } from '../utils/applicationContext';

export const useFiltersButton = () => {
  const { custom } = useApplicationContext();
  const subdomain = useSelector(selectSubdomain(custom.subdomain));
  const locationId = useSelector(selectLocationId);

  return useCallback(() => {
    window.location.href = getFiltersUrl({ subdomain, locationId });
  }, [locationId, subdomain]);
};

interface IParams {
  subdomain: string;
  locationId?: number;
}

function getFiltersUrl({ subdomain, locationId }: IParams) {
  const query = new URLSearchParams(window.location.search);

  /* istanbul ignore else */
  if (locationId) {
    query.append('region', String(locationId));
  }

  return `https://${subdomain}.cian.ru/country-builders-filters/?${query}`;
}
